import * as Accordion from '@radix-ui/react-accordion';
import clsx from 'clsx';
import { PropsWithChildren } from 'react';
import { CheckboxGroup } from '../Inputs/Checkbox/CheckboxGroup';
import { RadioGroup } from '../Inputs/RadioField/RadioGroup';
import { Spinner } from '../Spinner/Spinner';
import type { ListProps, ListWrapperProps } from './ListTypes';

const Wrapper = (props: ListWrapperProps) => {
  if (props.interactionType === 'radio') {
    const { interactionType, ...rest } = props;
    return <RadioGroup {...rest}>{props.children}</RadioGroup>;
  }

  if (props.interactionType === 'checkbox') {
    const { interactionType, ...rest } = props;
    return <CheckboxGroup {...rest} />;
  }

  if (props.interactionType === 'accordion') {
    const { interactionType, ...rest } = props;
    return <Accordion.Root {...rest}>{props.children}</Accordion.Root>;
  }

  if (props.interactionType === 'static') {
    return <>{props.children}</>;
  }
};

export const List = (props: ListProps) => {
  const { loading, grouping, ...restProps } = props;

  return (
    <Wrapper {...restProps}>
      <ul className={clsx({ 'space-y-xs': grouping === 'separated' })}>
        {props.children}
      </ul>
      {loading && (
        <div className="flex justify-center mt-xs">
          <Spinner />
        </div>
      )}
    </Wrapper>
  );
};

const Group = ({ label, children }: PropsWithChildren & { label: string }) => {
  return (
    <li className="[&:not(:first-child)]:mt-l">
      <fieldset>
        <legend className="text-content-subdued text-label-strong mb-s w-full">
          {label}
        </legend>
        <ul>{children}</ul>
      </fieldset>
    </li>
  );
};

List.Group = Group;
